module.exports = __webpack_public_path__ + "static/img/toubu.f364bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/toubu.png
// module id = KV+B
// module chunks = 9